<template>
    <main id="main" class="main-site">
        <div class="container">
            <div class="wrap-breadcrumb">
                <ul>
                    <li class="item-link">
                        <router-link to="/loja" class="fa fa-home"></router-link>
                    </li>
                    <li class="item-link">
                        <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
                    </li>
                    <li class="item-link">
                        <span>RMA Online</span>
                    </li>
                </ul>
            </div>
            <div class="row">
                <div class="col-lg-7 col-centered">
                    <iframe v-if="loaded" v-bind:src="url" width="0" scrolling="no" height="600" marginheight="0" frameborder="0" name="conteudo" vspace="0" hspace="0" style="width: 100%; z-index: 1; height: 902px; background-color: rgb(255, 255, 255);"></iframe>
                </div>
            </div>      
        </div>        
    </main>
</template>
<style>
.col-centered{
    float: none;
    margin: 0 auto;
}
</style>
<script>
    export default {

        name: "RMA",
        components: {
        },
        data() {
            return {
                url: '',
                loaded: false,
            }
        },
        watch: {
        },
        computed: {
        },
        mounted: function () {
            const self = this;
            $.ajax({
                url: this.$apiUrl + "Session.svc/getsessions",
                dataType: "json",
                type: "GET",
                xhrFields: { withCredentials: true },
                error: () => {
                    swal({
                        title: "É necessário estar logado",
                        icon: "warning"
                    }).then(() => location.href = `${self.$SiteUrl}/login?redirectTo=${location.href}`)
                }
            });

            this.loadSessionData();
        },

        methods: {

            loadSessionData: function () {
                const self = this;
                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = () => {
                    if (xhr.readyState == 4 && xhr.status == 200) {
                        let json = JSON.parse(xhr.responseText);
                        this.url = json;
                        this.loaded = true
                    }
                }
                xhr.open("GET", this.$apiUrl + "Session.svc/geturloldsite?tipo=R");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send();
            }

        }
    };
</script>
